import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ExternalLinkIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z'
                fill='currentColor'
            />
        </>
    ),
})

ExternalLinkIcon.displayName = 'ExternalLinkIcon'
